const awsConfig = {
  Auth: {
    Cognito: {
      userPoolClientId: "j2f45kuk6cbsrmgm012mlk0s9",
      region: "ap-southeast-1",
      userPoolId: "ap-southeast-1_zbWDZKlD7",
      loginWith: {
        oauth: {
          domain:
            "ap-southeast-1zbwdzkld7.auth.ap-southeast-1.amazoncognito.com",
          scopes: ["openid email profile aws.cognito.signin.user.admin"],
          redirectSignIn: [`${window.location.origin}`],
          redirectSignOut: [`${window.location.origin}`],
          responseType: "code",
        },
        username: "true",
        email: "false", // Optional
        phone: "false", // Optional
      },
    },
  },
  API: {
    GraphQL: {
      endpoint:
        "https://qkb257k5qjhcnelllckfepwmqq.appsync-api.ap-southeast-1.amazonaws.com/graphql",
      region: "ap-southeast-1",
      // Set the default auth mode to "apiKey" and provide the API key value
      defaultAuthMode: "userPool",
    },
  },
};

const integrationConfig = {
  genEzeLogin: "https://saletool-sit.generali.co.th/logincognito",
};

const logoutUri = `https://${awsConfig.Auth.Cognito.loginWith.oauth.domain}/logout?client_id=${awsConfig.Auth.Cognito.userPoolClientId}&response_type=${awsConfig.Auth.Cognito.loginWith.oauth.responseType}&redirect_uri=${encodeURIComponent(window.location.origin)}`;

const config = { awsConfig, integrationConfig, logoutUri };

export default config;
